import { lang } from '@umu/ukit-lang';
import './whitePaperBanner.scss';
import React from 'react';
import { If, PreImg } from 'common/src/components';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    hasSubmitted: boolean;
    changeHasSubmitted: Function;
}

const WHITE_PAPER_URL =
    'https://statics-cdn-cn.umucdn.cn/statics/home/%E6%B7%B7%E5%90%88%E5%BC%8F%E5%AD%A6%E4%B9%A03.0.pdf';

export const WhitePaperBanner = (props: IProp) => {
    console.log('banner props', props);
    return (
        <div className={props.platform === 'twww' ? 'white-paper-banner' : 'white-paper-banner white-m-paper-banner'}>
            <If condition={props.platform === 'twww'}>
                <div className="section-head-img">
                    <PreImg>
                        <img className="user-img-twww" src={require(`./images/bg-cover.png`)} alt="" />
                    </PreImg>
                </div>
            </If>
            <If condition={props.platform === 'mobile'}>
                <PreImg>
                    <img className="user-img" src={require(`./images/bg-cover-m.png`)} alt="" />
                </PreImg>
            </If>
            <div className="white-paper-container">
                <img className="paper-cover" src={require('./images/paper-cover.png')} alt="" />
                <If condition={!props.hasSubmitted}>
                    <div className="detail">
                        <div className="title">{lang('混合式学习 3.0 白皮书')}</div>
                        <div className="des">{lang('填写表单，马上获取')}</div>
                    </div>
                </If>
                <If condition={props.hasSubmitted}>
                    <div className="detail">
                        <div className="title">{lang('感谢您下载白皮书')}</div>
                        <div className="des submitted-des">
                            {lang('您的信息已提交成功，您可点击下方按钮查看，并在右上角点击保存。')}
                        </div>
                        <a className="viewnow" target="_blank" href={WHITE_PAPER_URL} rel="noreferrer">
                            {lang('立即查看')}
                        </a>
                    </div>
                </If>
            </div>
        </div>
    );
};
